export default {
    'name': 'fireWrapper',
    'label': 'legal.tabs.FileWrapper',
    'getComponent': () => import('./file-wrapper.vue'),
    'tabIndex': 3,
    'left': false,
    'right': false,
    'singleView': true,
    'exclusiveRoutePath': '/legal/file-wrapper',
};
